import { User } from "@/interfaces";
import api from "@/lib/axios";
import { DefaultGetRequestParams, DefaultResponse } from "./types";

export interface DriverLeave {
  id: number;
  start_date: string;
  end_date: string;
  reason: string;
  driver_id: number;
  driver: User;
}

interface DriverLeaveInput {
  start_date: string;
  end_date: string;
  reason: string;
  driver_id: number;
}

export const driverLeaveService = {
  async index({
    page,
    per_page,
    search,
    filters = {},
  }: DefaultGetRequestParams) {
    const response = await api.get<DefaultResponse<DriverLeave>>(
      "/driver_leave",
      {
        params: {
          page: page,
          per_page: per_page,
          search: search,
          ...filters,
        },
      },
    );
    return response.data;
  },

  async destroy(id: number) {
    const response = await api.delete(`/driver_leave/${id}`);
    return response.data;
  },

  async show(id: number) {
    const response = await api.get<DefaultResponse<DriverLeave, false>>(
      `/driver_leave/${id}`,
    );
    return response.data;
  },

  async update(id: number, data: DriverLeaveInput) {
    const response = await api.put(`/driver_leave/${id}`, data);
    return response.data;
  },

  async create(data: DriverLeaveInput) {
    const response = await api.post("/driver_leave", data);
    return response.data;
  },

  async getDriverLeavesByDriver(driverId: number) {
    const response = await api.get<DefaultResponse<DriverLeave>>(
      `/driver/${driverId}/leaves`,
    );
    return response.data;
  },
};
